import React from 'react';
import { connect } from 'react-redux';

import { fetchCalendar, toggleBids, toggleDeliveries, toggleJobs,changeWeekView,toggleAppoinments } from '../redux/calendar';
import { fetchStandardCrews } from '../redux/standardCrews';
import { fetchDropdowns } from '../redux/dropdowns';
import { fetchOrganization } from '../redux/organization';
import { fetchAvailableBids } from '../redux/searchBids';
import { fetchAvailableJobs,setJobToggle } from '../redux/searchJobs';
import { fetchAvailablePurchaseOrders } from '../redux/searchPurchaseOrders';
import { fieldsSelector, loadSavedSettings, updateSettings } from '../redux/settings';
import { fetchTokenInfo } from '../redux/tokenInfo';
import { fetchWorkOrderTemplates } from '../redux/workOrders';
import Scheduler from '../components/Scheduler';
import { fetchAvailableEmployees,setEmployeeToggle } from '../redux/searchEmployees'
import { fetchEquipments } from '../redux/equipments'
import { fetchAvailableAppointments } from '../redux/searchAppointments';
import { searchCustomers } from '../redux/searchAppointments';
import { searchDatasheets } from '../redux/searchAppointments';



class SchedulerContainer extends React.Component {

  componentDidMount() {
    const {
      date,
      mode,
      onNeedAvailableBids,
      onNeedAvailableJobs,
      onNeedAvailablePurchaseOrders,
      onNeedCalendar,
      onNeedDropdowns,
      onNeedOrganization,
      onNeedSavedSettings,
      onNeedStandardCrews,
      onNeedTokenInfo,
      onNeedWorkOrderTemplate,
      onNeedAvailableEmployees,
      onNeedEquipments,
      onNeedAvailableAppointments,
      onNeedAppointmentCustomer,
      onNeedDataSheets
    } = this.props;
    onNeedSavedSettings();
    onNeedTokenInfo();
    onNeedOrganization();
    onNeedCalendar(date, mode);
    onNeedStandardCrews();
    onNeedDropdowns();
    onNeedAvailableJobs();
    onNeedAvailablePurchaseOrders();
    onNeedAvailableBids();
    onNeedWorkOrderTemplate();
    onNeedAvailableEmployees();
    onNeedEquipments();
    onNeedAvailableAppointments();
    onNeedAppointmentCustomer();
    onNeedDataSheets();
  }

  render() {
    return <Scheduler {...this.props} />;
  }

}

const mapStateToProps = (state) => ({
  loading: state.events.loading,
  mode: state.calendar.mode,
  showBids: state.calendar.showBids,
  showAppointments:state.calendar.showAppointments,
  showDeleteModal: state.modals.deleteModal.show,
  showDeliveries: state.calendar.showDeliveries,
  showJobs: state.calendar.showJobs,  
  showSearch: (state.calendar.mode === 'week'|| state.calendar.mode === 'day') && state.tokenInfo.scope.indexOf('calendarEvents:create') > -1,
  entity: state.settings.entity,
  schedulerView:state.settings.schedulerView,
  employeeSearchToggle:state.settings.employeeSearchToggle,
  jobSearchToggle:state.settings.jobSearchToggle,
  showEmployees: state.calendar.mode === 'week' && state.tokenInfo.scope.indexOf('calendarEvents:create') > -1 ,
  activeEquipment:state.calendar.activeEquipment,
  employeeToggle:state.searchEmployees.employeeToggle,
  jobToggle:state.searchJobs.jobToggle,
  selectedWeekView:state.calendar.selected_week_view,
  
  
  //employees: state.employees
  
});

const mapDispatchToProps = {
  onBidsTabClick: () => updateSettings({ entity: 'bids' }),
  onDeliveriesTabClick: () => updateSettings({ entity: 'purchaseOrders' }),
  onJobsTabClick: () => updateSettings({ entity: 'jobs' }),  
  onAppointmentsTabClick: () => updateSettings({ entity: 'appointments',schedulerView:'equipment' }),  
  onNeedAvailableBids: fetchAvailableBids,
  onNeedAvailableJobs: fetchAvailableJobs,
  onNeedAvailablePurchaseOrders: fetchAvailablePurchaseOrders,
  onNeedCalendar: fetchCalendar,
  onNeedDropdowns: fetchDropdowns,
  onNeedOrganization: fetchOrganization,
  onNeedSavedSettings: loadSavedSettings,
  onNeedStandardCrews: fetchStandardCrews,
  onToggleBids: toggleBids,
  onToggleDeliveries: toggleDeliveries,
  onToggleJobs: toggleJobs,
  onToggleAppointments:toggleAppoinments,
  onNeedTokenInfo: fetchTokenInfo,
  onNeedWorkOrderTemplate: fetchWorkOrderTemplates,
  onNeedAvailableEmployees: fetchAvailableEmployees,
  onNeedEquipments: fetchEquipments,
  setEmployeeToggle:(toggle)=>updateSettings({ employeeSearchToggle: toggle }),
  setJobToggle:(toggle)=>updateSettings({ jobSearchToggle: toggle }),
  //setJobToggle:setJobToggle,
  changeWeekView:changeWeekView,
  onNeedAvailableAppointments:fetchAvailableAppointments,
  onNeedAppointmentCustomer:searchCustomers,
  onNeedDataSheets:searchDatasheets
  
};

export default connect(mapStateToProps, mapDispatchToProps)(SchedulerContainer);
